
import React from 'react';

const ButtonReserveOrder = ({ setReserved, isDisabled = false }) => (
  <button className="btn btn-light btn-md2 mb15 ml10" type="button" disabled={isDisabled} onClick={setReserved}>Reserve</button>
);

export default ButtonReserveOrder;
